import { Line, Text } from "@react-three/drei";
import { useFrame } from "@react-three/fiber";
import { useRef } from "react";
import { BEAM_LEFT_OFFSET, SERIF } from "../../constants";
import { useSettings } from "../../hooks/useSettings";
import { useShelvingStore, useStoreRoom } from "../../store";

export const OffsetCeilingDimensionVertical = () => {
    const groupRef = useRef<any>(null);
    const ref = useRef<any>(null);
    const textRef = useRef<any>(null);

    useFrame(() => {
        const currentShelving = useShelvingStore.getState().getCurrentShelving();

        const offsetCeiling = currentShelving.offsetCeiling;
        const sideIndent = currentShelving.sideIndent;

        const roomLength = useStoreRoom.getState().length;
        const roomHeight = useStoreRoom.getState().height;

        const roomDepth = useStoreRoom.getState().depth;
        const width = ["left", "right"].includes(currentShelving.name) ? roomDepth : roomLength;

        if (groupRef.current) {
            groupRef.current.scale.y = offsetCeiling / 1000;
            groupRef.current.position.x = -(width / 2 - sideIndent) / 1000;
            //FIXME почему "-5"?
            groupRef.current.position.y = (roomHeight - offsetCeiling - 5) / 1000;
            groupRef.current.position.z = 0.1;

            textRef.current.position.x =
                sideIndent <= 300
                    ? -(width / 2 - sideIndent - BEAM_LEFT_OFFSET * 1.5) / 1000
                    : -(width / 2 - sideIndent + BEAM_LEFT_OFFSET * 1.5) / 1000;

            textRef.current.position.y = (roomHeight - offsetCeiling / 2 - 5) / 1000;
            textRef.current.rotation.z = Math.PI / 2;
            textRef.current.text = offsetCeiling;
            textRef.current.position.z = 0.1;
        }
    });
    
    const { isVisibleSizes } = useSettings();
    if (!isVisibleSizes) {
        return null;
    }

    return (
        <group>
            <group ref={groupRef}>
                <Line
                    points={[
                        [-SERIF, 0, 0],
                        [SERIF, 0, 0],
                    ]}
                    lineWidth={1}
                    color="white"
                />
                <Line
                    points={[
                        [-SERIF, 1, 0],
                        [SERIF, 1, 0],
                    ]}
                    lineWidth={1}
                    color="white"
                />
                <Line
                    ref={ref}
                    points={[
                        [0, 0, 0],
                        [0, 1, 0],
                    ]}
                    lineWidth={0.5}
                    color="white"
                />
            </group>
            <Text ref={textRef} color="white" anchorX="center" anchorY="middle">
                {" "}
            </Text>
        </group>
    );
};
